<template>
  <header class="header-nav">
    <div class="logo-container">
      <router-link to="/">
        <img src="../assets/rc_logo1.png" alt="餐馆Logo" class="logo-image">
      </router-link>
    </div>
    
    <!-- 添加了 class="main-nav" 以匹配 CSS -->
    <nav class="main-nav">
      <router-link to="/" class="nav-link">Home 餐馆介绍</router-link>
      <router-link to="/full-screen-menu" class="nav-link">Menu 菜单</router-link>
      
      <!-- 这里是修改后的点餐按钮 -->
      <!-- 注意：使用 href="/order/" 进行跳转，且移除了外层 div，直接应用样式 -->
      <a href="/order/" class="nav-link highlight-link">
        🍽️ 在线点餐
      </a>
      
      <router-link to="/reserve" class="nav-link">Kontakt 联系我们</router-link>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderNav',
};
</script>

<style scoped>
/* 头部整体容器 */
.header-nav {
  background-color: #c5a37c; /* 保持原背景色 */
  color: white;
  width: 100%;
  height: 80px; /* 给定一个固定高度，防止抖动 */
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem; /* 左右内边距 */
  box-sizing: border-box; /* 确保 padding 不会撑大宽度 */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1); /* 加一点点阴影更有层次感 */
}

/* Logo 区域 */
.logo-container {
  display: flex;
  align-items: center;
  flex-shrink: 0; /* 防止 Logo 被挤压 */
}

.logo-image {
  height: 50px; /* 调整合适的高度 */
  width: auto;
  display: block;
  cursor: pointer;
}

/* 导航区域 */
.main-nav {
  display: flex;
  align-items: center;
  gap: 10px; /* 这是一个现代 CSS 属性，直接控制子元素间距，比 margin 更稳 */
}

/* 通用导航链接样式 */
.nav-link {
  color: white;
  text-decoration: none;
  padding: 0.6rem 1rem;
  border-radius: 4px;
  font-size: 1rem;
  transition: all 0.3s ease;
  white-space: nowrap; /* 防止文字换行 */
  display: flex;
  align-items: center;
}

/* 鼠标悬停效果 */
.nav-link:hover,
.nav-link.router-link-active {
  background-color: rgba(255, 255, 255, 0.2);
}

/* 特殊样式的点餐按钮 (高亮风格) */
.highlight-link {
  border: 1px solid rgba(255, 255, 255, 0.6); /* 加个半透明边框 */
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.1);
}

.highlight-link:hover {
  background-color: #fff;
  color: #c5a37c; /* 悬停时变成白底金字 */
  border-color: #fff;
}

/* --- 移动端适配 (屏幕小于 768px) --- */
@media (max-width: 768px) {
  .header-nav {
    padding: 0 10px; /* 减少左右边距 */
    height: 60px; /* 移动端高度减小 */
  }

  .logo-image {
    height: 30px; /* 缩小 Logo */
    margin-right: 5px;
  }
  
  /* 隐藏部分文字，或者减小字号以放下所有按钮 */
  .nav-link {
    padding: 4px 6px;
    font-size: 12px; /* 缩小字号 */
    margin: 0;
    border-radius: 3px;
  }
  
  .main-nav {
    gap: 2px; /* 缩小间距 */
    width: 100%;
    justify-content: flex-end; /* 靠右对齐 */
  }
  
  /* 如果手机屏幕实在太小，可以把点餐按钮单独做样式优化 */
  .highlight-link {
    background-color: rgba(255,255,255,0.2);
    border: none;
  }
}
</style>
